import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-12" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "col-sm-12" }
const _hoisted_12 = { class: "col-sm-12" }
const _hoisted_13 = {
  key: 0,
  class: "text-danger mt-3",
  role: "alert"
}
const _hoisted_14 = { class: "text-center mt-5" }
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_options_selector = _resolveComponent("options-selector")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
        disabled: _ctx.saving
      }, _hoisted_5, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Garment",
                  text: "Garment"
                })
              ]),
              (!_ctx.saving)
                ? (_openBlock(), _createBlock(_component_options_selector, {
                    key: 0,
                    modelValue: _ctx.selectedGarments,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedGarments) = $event)),
                    options: _ctx.garments,
                    keyProp: "identifier",
                    labelProp: "text"
                  }, null, 8, ["modelValue", "options"]))
                : (_openBlock(), _createBlock(_component_localized_text, {
                    key: 1,
                    localizedKey: "Saving...",
                    text: "Saving..."
                  }))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_form_field, {
              type: "date",
              labelKey: "Expiration date",
              labelValue: "Expiration date",
              placeholderKey: "Expiration date",
              placeholderValue: "Expiration date",
              modelValue: _ctx.vm.garmentLicense.expiresOn,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.vm.garmentLicense.expiresOn) = $event)),
              readonly: _ctx.saving
            }, null, 8, ["modelValue", "readonly"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_form_field, {
              type: "number",
              labelKey: "Concurrent Accesses",
              labelValue: "Concurrent Accesses",
              placeholderKey: "Concurrent Accesses",
              placeholderValue: "Concurrent Accesses",
              step: "1",
              min: "1",
              modelValue: _ctx.vm.garmentLicense.simultaneousAccessNumber,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.vm.garmentLicense.simultaneousAccessNumber) = $event)),
              readonly: _ctx.saving
            }, null, 8, ["modelValue", "readonly"])
          ])
        ])
      ]),
      (_ctx.saveFailed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_localized_text, {
              localizedKey: "Some licenses could not be saved. The remaining garments are still selected. Please try again.",
              text: "Some licenses could not be saved. The remaining garments are still selected. Please try again."
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
          disabled: _ctx.disabled
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Save",
            text: "Save"
          })
        ], 8, _hoisted_15)
      ])
    ])
  ]))
}